module.exports = __webpack_public_path__ + "static/media/gt.7417fcde.webp";